/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_Workflow_1Inputs */

const en_visa_eb5_workflow_1 = /** @type {(inputs: Visa_Eb5_Workflow_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepare and file the immigrant petition with the available evidence.`)
};

const pt_visa_eb5_workflow_1 = /** @type {(inputs: Visa_Eb5_Workflow_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparar e apresentar a petição de imigrante com as evidências disponíveis.`)
};

const es_visa_eb5_workflow_1 = /** @type {(inputs: Visa_Eb5_Workflow_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparar y presentar la petición de inmigrante con la evidencia disponible.`)
};

/**
* | output |
* | --- |
* | "Prepare and file the immigrant petition with the available evidence." |
*
* @param {Visa_Eb5_Workflow_1Inputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_workflow_1 = /** @type {((inputs?: Visa_Eb5_Workflow_1Inputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_Workflow_1Inputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_workflow_1(inputs)
	if (locale === "es") return es_visa_eb5_workflow_1(inputs)
	return en_visa_eb5_workflow_1(inputs)
});